export const SEO_HREFLANG_COUNTRIES: { [language: string]: string[] } = {
  de: ['de', 'ch', 'at', 'li'],
  en: [
    'us',
    'gb',
    'ca',
    'au',
    'ch',
    'se',
    'no',
    'nl',
    'dk',
    'kw',
    'pl',
    'ro',
    'ae',
    'hr',
    'cz',
    'sa',
    'hu',
    'gr',
    'tr',
    'fi',
    'si',
    'is',
  ],
  es: [
    'es',
    'mx',
    'hn',
    'pr',
    'cl',
    'ar',
    'cr',
    'pe',
    'py',
    'co',
    'do',
    'gt',
    'pa',
    'uy',
    've',
  ],
  fr: ['fr', 'be', 'lu', 'ch', 'ca', 'mc', 'eg', 'dz', 'ci', 're', 'bl', 'lc'],
  it: ['it', 'ch'],
  pt: ['pt', 'br'],
  ru: ['by', 'kz', 'kg'],
  zht: ['hk', 'tw'],
  zh: ['cn'],
};
